import React, {Component, Fragment} from 'react';
import {Query} from '@apollo/client/react/components';
import {reach} from '@hapi/hoek';
import {HOME_PAGE_QUERY} from './homePageQuery';
import PageMeta from '../../components/PageMeta/PageMeta';
import JsonSchema from './HomePageJsonSchema';
import CardCarousel from '../../components/CardCarousel/CardCarousel';
import {HomeRouteContext} from '../../utils/context';
import withQuery from '../../utils/withQuery';
import HeroHeader from '../../components/HeroHeader/HeroHeader';
import HomeCarousel from '../../components/HomeCarousel/HomeCarousel';
import FeaturedArticlesSection from '../../components/FeaturedArticlesSection/FeaturedArticlesSection';
import FeaturedCallOutsSection from '../../components/FeaturedCallOutsSection/FeaturedCallOutsSection';

const LoadedHomePage = (props) => {
    const {systemData, translations, response, homeRoute} = props;
    const {isMobile, isTablet, hostname, basePath} = systemData;
    const isDevice = isMobile || isTablet;
    const {homeCollection, categoryCollection} = response.data || {};
    const homepage = reach(homeCollection, 'items.0');

    if (!homepage) {
        return null;
    }

    const {
        headline,
        introduction,
        slideshowCollection,
        featuredArticlesTitle,
        featuredArticlesCollection,
        callOutsCollection,
    } = homepage;

    const categories = reach(categoryCollection, 'items');
    const schemaArticles = reach(homepage, 'slideshowCollection.items');
    const canonical = `https://${hostname}${basePath}${homeRoute}`;
    const externalLinkCarousel = reach(homepage, 'externalLinkCarousel') || {};

    return (
        <Fragment>
            <PageMeta
                {...{
                    metaTitle: homepage.metaTitle,
                    metaDescription: homepage.metaDescription,
                    hreflangData: homepage.hreflang,
                    systemData,
                }}
                canonical={canonical}
                heroFile={reach(schemaArticles, '0.heroFile')}
            />
            <JsonSchema articles={schemaArticles} canonical={canonical} />
            <HeroHeader title={headline} content={introduction} />
            <HomeCarousel articles={slideshowCollection.items} />
            <CardCarousel
                id="categories"
                title={translations.browseByCategory}
                translations={translations}
                cards={categories}
                isDevice={isDevice}
            />
            <FeaturedArticlesSection
                id="featured-articles"
                title={featuredArticlesTitle}
                articles={featuredArticlesCollection.items}
            />
            <FeaturedCallOutsSection
                id="featured-call-outs"
                callOuts={callOutsCollection.items}
            />
            <CardCarousel
                id="external-links"
                title={externalLinkCarousel.title}
                cards={reach(
                    externalLinkCarousel,
                    'externalLinksCollection.items',
                )}
                translations={translations}
                isDevice={isDevice}
            />
        </Fragment>
    );
};

const HomePageWithLoading = withQuery(LoadedHomePage);

class HomePageContainer extends Component {
    render() {
        const {client, systemData, homeId, preview} = this.props;
        const variables = {
            sitename: systemData.siteName,
            homeId,
            preview,
        };

        return (
            <Query client={client} {...{query: HOME_PAGE_QUERY, variables}}>
                {(response) => {
                    return (
                        <HomeRouteContext.Consumer>
                            {(homeRoute) => (
                                <HomePageWithLoading
                                    {...{...this.props, response, homeRoute}}
                                />
                            )}
                        </HomeRouteContext.Consumer>
                    );
                }}
            </Query>
        );
    }
}

export default HomePageContainer;
